import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { HRDashboardStyled } from '../../components';
import DocumentsDatatable from './DocumentDataTable';
import { signaturesRequest } from '../../requests/dashboards';

const DocumentIndex = () => {
  const [answeredCard, setAnsweredCard] = useState([]);
  const [approvedCard, setApprovedCard] = useState([]);
  const [customParams, setCustomParams] = useState({ with_history: false });
  const dispatch = useDispatch();
  const [moreData, setMoreData] = useState(false);
  const [pendingCard, setPendingCard] = useState([]);
  const [rejectedCard, setRejectedCard] = useState([]);
  const [onRequest, setOnRequest] = useState(true);
  const [total, setTotal] = useState(0);

  const updateCardValues = response => {
    setOnRequest(false);
    const { documents } = response.data;
    setAnsweredCard(documents.answered);
    setApprovedCard(documents.approved);
    setPendingCard(documents.pending);
    setRejectedCard(documents.rejected);
    setTotal(documents.total);
  };

  const fetchDashboardCards = () => {
    setOnRequest(true);
    const request = async () => signaturesRequest({ dispatch, successCallback: updateCardValues });
    request();
  };

  useEffect(() => window.scrollTo(0, 0), []);
  useEffect(fetchDashboardCards, []);

  return (
    <>
      <h2 className="m-top mb-3">Firma Digital</h2>
      <Row>
        <Col className="mt-2" md={4} xl={3} xs={12}>
          <HRDashboardStyled
            title={`${answeredCard[1]}%`}
            label="Documentos Respondidos"
            TopHeaderColor="#fff"
            subtitle2={`${answeredCard[0]} / ${total} Documento(s) Aprobados/Firmados o Rechazados`}
            TypeCard="OnlyInformation"
            CardName="Colaborators"
            onRequest={onRequest}
            customLabelStyle={{ color: '#666666' }}
            customTitleStyle={{ fontSize: '15px', fontWeight: 'bold', color: '#666666' }}
            fontSizeSubtitle="14px"
            customSubtitle2Style={{ fontWeight: 'bold', color: '#666666', fontSize: '12px' }}
            titleSize="16px"
          />
        </Col>

        <Col className="mt-2" md={4} xl={3} xs={12}>
          <HRDashboardStyled
            title={`${approvedCard[1]}%`}
            label="Documentos Aprobados/Firmados"
            TopHeaderColor="#fff"
            subtitle2={`${approvedCard[0]} / ${total} Documento(s) Aprobados /Firmados`}
            TypeCard="OnlyInformation"
            CardName="Colaborators"
            onRequest={onRequest}
            GeneralColor="#21653b"
            customLabelStyle={{ color: '#666666' }}
            customTitleStyle={{ fontSize: '15px', fontWeight: 'bold', color: '#666666' }}
            fontSizeSubtitle="14px"
            customSubtitle2Style={{ fontWeight: 'bold', color: '#666666', fontSize: '12px' }}
            titleSize="16px"
          />
        </Col>

        <Col className="mt-2" md={4} xl={3} xs={12}>
          <HRDashboardStyled
            title={`${rejectedCard[1]}%`}
            label="Documentos Rechazados"
            TopHeaderColor="#fff"
            subtitle2={`${rejectedCard[0]} / ${total} Documento(s) Rechazados`}
            TypeCard="OnlyInformation"
            CardName="Colaborators"
            onRequest={onRequest}
            GeneralColor="#b40000"
            customLabelStyle={{ color: '#666666' }}
            customTitleStyle={{ fontSize: '15px', fontWeight: 'bold', color: '#000' }}
            fontSizeSubtitle="14px"
            customSubtitle2Style={{ fontWeight: 'bold', color: '#666666', fontSize: '12px' }}
            titleSize="16px"
          />
        </Col>

        <Col className="mt-2" md={4} xl={3} xs={12}>
          <HRDashboardStyled
            title={`${pendingCard[1]}%`}
            label="Documentos Pendientes"
            TopHeaderColor="#fff"
            subtitle2={`${pendingCard[0]} / ${total} Documento(s) por Aprobar/Firmar`}
            TypeCard="OnlyInformation"
            CardName="Colaborators"
            onRequest={onRequest}
            GeneralColor="#ffc107"
            customLabelStyle={{ color: '#666666' }}
            customTitleStyle={{ fontSize: '15px', fontWeight: 'bold', color: '#000' }}
            fontSizeSubtitle="14px"
            customSubtitle2Style={{ fontWeight: 'bold', color: '#666666', fontSize: '12px' }}
            titleSize="16px"
          />
        </Col>
      </Row>

      <DocumentsDatatable
        customParams={customParams}
        setCustomParams={setCustomParams}
        moreData={moreData}
        setMoreData={setMoreData}
        employeeSearch
        advanceFilters
        rrhh
        allowedActions={['download', 'remove', 'resend', 'show', 'request-sign', 'observation']}
      />
    </>
  );
};

export default DocumentIndex;
